<script setup lang="ts">
interface Props {
  width?: number;
  height?: number;
}

withDefaults(defineProps<Props>(), {
  width: 24,
  height: 24,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.44 11.05L12.25 20.24C11.1242 21.3658 9.59723 21.9983 8.005 21.9983C6.41277 21.9983 4.88584 21.3658 3.76 20.24C2.63416 19.1142 2.00166 17.5872 2.00166 15.995C2.00166 14.4028 2.63416 12.8758 3.76 11.75L12.33 3.18C13.0806 2.42944 14.0993 2.00681 15.16 2.00681C16.2207 2.00681 17.2394 2.42944 17.99 3.18C18.7406 3.93056 19.1632 4.94927 19.1632 6.01C19.1632 7.07073 18.7406 8.08944 17.99 8.84L9.41 17.41C9.03473 17.7853 8.52544 17.9966 7.995 17.9966C7.46456 17.9966 6.95527 17.7853 6.58 17.41C6.20473 17.0347 5.99341 16.5254 5.99341 15.995C5.99341 15.4646 6.20473 14.9553 6.58 14.58L14.58 6.58"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
